// Set a value in web local storage
// Takes param of mode, which should be 'supplier', 'client' or ''
export function setModeLocalStorage(mode: string) {
  window.localStorage.setItem('userMode', mode);
}

export function clearModeLocalStorage() {
  window.localStorage.removeItem('userMode');
}

// Returns value from web local storage
export function getModeLocalStorage() {
  return window.localStorage.getItem('userMode');
}
